
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';


export class InputWidgetArray extends Component {

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    emptyValue: PropTypes.any
  };

  static defaultProps = {
    emptyValue: []
  }

  handleChange = (e) => {
    const { onChange, emptyValue } = this.props;
    let value = e.target.value;
    value = value.split('\n');
    value = _.filter(value, (val) => typeof val === 'string' && val.length > 0);

    onChange(value.length === 0 ? emptyValue : value);
  };

  render() {
    let { value, ...otherProps } = this.props;
    let widgetValue = value.join('\n');

    return (
      <TextField
        type="text"
        variant="outlined"
        multiline={true}
        {...otherProps}
        value={widgetValue}
        onChange={(e) => this.handleChange(e)}
      />
    )
  }
}
